<template>
  <div class="main applyMain">
    <!-- 上部分 -->
    <div class="title">
      <span class="text">会议报名</span>
    </div>
    <!-- 下部分 -->
    <!-- 表格 -->
    <div class="table">
      <el-table
        :data="tableData"
        border
        stripe
        style="width: 99%;height: 530px;overflow-y: scroll;"
        :header-row-style="{color: '#666'}"
      >
        <el-table-column align="center" prop="orderNumber" label="序号" type="index" :index="increamentIndex" width="80"></el-table-column>
        <el-table-column align="center" prop="title" label="会议名称"></el-table-column>
        <el-table-column align="center" prop="begindate" label="会议日期"></el-table-column>
        <el-table-column align="center" prop="applyenddate" label="截止日期"></el-table-column>
        <el-table-column align="center" prop="address" label="会议地点"></el-table-column>
        <el-table-column align="center" prop="activity" label="会议类别"></el-table-column>
        <el-table-column align="center" prop="peoplenum" label="额定人数"></el-table-column>
        <el-table-column align="center" prop="website" label="活动链接">
          <p slot-scope="scope">
            <a
              :href="scope.row.website"
              target="_blank"
              style="text-decoration: none;color: #01AAED;"
            >{{scope.row.website}}</a>
          </p>
        </el-table-column>
        <el-table-column align="center" style="white-space: nowrap;" width="120">
          <template slot-scope="scope">
            <div>
              <el-button type="primary" size="mini" @click="signUp(scope.row)">会议报名</el-button>
            </div>
            <div style="margin-top: 5px">
              <el-button type="primary" size="mini" @click="detail(scope.row)">报名详情</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div>

    <!-- 会议报名弹框 -->
    <el-dialog
      title="会议报名"
      :visible="signUpDialogVisible"
      :before-close="closeSignUpDialog"
      top="1vh"
    >
      <!-- 输入框 -->
      <el-form label-position="right" label-width="100" v-model="formData" class="width-200">
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item label="所在单位">
              <el-input v-model="formData.company" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="姓名">
              <el-input v-model="formData.name" @blur="getByName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="联系电话">
              <el-input v-model="formData.phone"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="职务">
              <el-input v-model="formData.job"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-button type="primary" size="small" @click="add">添加</el-button>
          </el-col>
        </el-row>
      </el-form>

      <!-- 上表格 -->
      <p>常用联系人列表</p>
      <el-table :data="tableData4" style="width: 100%" max-height="180" size="small" :header-cell-style="{background:'#f5f7fa'}">
        <el-table-column align="center" type="index" :index="increamentIndex" label="序号" width="80" ></el-table-column>
        <el-table-column align="center" prop="company" label="会员单位"></el-table-column>
        <el-table-column align="center" prop="name" label="姓名"></el-table-column>
        <el-table-column align="center" prop="phone" label="电话"></el-table-column>
        <el-table-column align="center" prop="job" label="职位"></el-table-column>
        <el-table-column align="center">
          <template slot-scope="scope">
            <el-button type="primary" size="small" @click="increase(scope.row)">添加</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange4"
        @current-change="handleCurrentChange4"
        :current-page="currentPage4"
        :page-size="pageSize4"
        :total="total4"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>

      <!-- 下表格 -->
      <p style="margin-top: 35px;">会议报名人员列表</p>
      <el-table :data="tableData2" style="width: 100%;" max-height="180" size="small" :header-cell-style="{background:'#f5f7fa'}">
        <el-table-column align="center" type="index" :index="increamentIndex" label="序号" width="80" ></el-table-column>
        <el-table-column align="center" prop="company" label="会员单位"></el-table-column>
        <el-table-column align="center" prop="name" label="姓名"></el-table-column>
        <el-table-column align="center" prop="phone" label="电话"></el-table-column>
        <el-table-column align="center" prop="job" label="职位"></el-table-column>
        <el-table-column align="center">
          <template slot-scope="scope">
            <el-button type="danger" size="small" @click="remove(scope.row)">移除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange2"
        @current-change="handleCurrentChange2"
        :current-page="currentPage2"
        :page-size="pageSize2"
        :total="total2"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
      <div style="display: flex;justify-content: center; margin-top: 15px;">
        <el-button type="primary" @click="submit" >提交报名</el-button>
      </div>
    </el-dialog>

    <!-- 报名详情弹框 -->
    <el-dialog title="报名详情" :visible="detailDialogVisible" :before-close="closeDetailDialog" top="8vh">
      <el-table :data="tableData3" stripe border style="width: 100%;height: 550px;overflow-y: scroll;margin-top: 20px;">
        <el-table-column align="center" type="index" :index="increamentIndex" label="序号" width="80"></el-table-column>
        <el-table-column align="center" prop="company" label="会员单位"></el-table-column>
        <el-table-column align="center" prop="name" label="姓名"></el-table-column>
        <el-table-column align="center" prop="phone" label="电话"></el-table-column>
        <el-table-column align="center" prop="job" label="职位"></el-table-column>
        <el-table-column align="center" prop="state" label="状态">
          <template slot-scope="scope">
            {{stateMap[scope.row.state]}}
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange3"
        @current-change="handleCurrentChange3"
        :current-page="currentPage3"
        :page-size="pageSize3"
        :total="total3"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </el-dialog>
  </div>
</template>

<script>
import * as Cache from '../utils/cache'
import * as API from '../utils/apiService'

export default {
  data () {
    return {
      signUpDialogVisible: false, // 是否展示会议报名弹框
      detailDialogVisible: false, // 是否展示报名详情弹框
      tableData: [],
      tableData2: [],
      tableData3: [],
      tableData4: [],
      currentPage: 1,
      pageSize: 10,
      currentPage2: 1,
      pageSize2: 10,
      currentPage3: 1,
      pageSize3: 10,
      currentPage4: 1,
      pageSize4: 10,
      total: 0,
      total2: 0,
      total3: 0,
      total4: 0,
      eventid: '', // 会议id
      id: '', // 会员id
      state: '', // 0 添加 1 提交 2 退回 4 通过
      stateMap: {
        0: '添加',
        1: '提交',
        2: '退回',
        3: '通过'
      },
      formData: {
        company: '',
        name: '',
        job: '',
        phone: ''
      }
    }
  },
  mounted () {
    this.asyncGetEventForMem()
  },
  methods: {
    // 序号自增
    increamentIndex (index) {
      return index + (this.currentPage - 1) * this.pageSize + 1
    },
    // 根据姓名查询
    getByName () {
      let params = {
        name: this.formData.name,
        membershipid: this.id
      }
      API.getEventSignUpByName(params).then(resp => {
        if (resp.resultCode === '0000') {
          this.formData.phone = resp.data.phone
          this.formData.job = resp.data.job
        }
      })
    },

    // 会议报名
    signUp (item) {
      let params = {
        eventid: item.id,
        membershipid: this.id
      }
      API.getSignUpState(params).then(resp => {
        if (resp === false) {
          this.$message.error('已提交，无法修改!')
          return
        } else {  
          this.signUpDialogVisible = true
          this.asyncGetLinkMenForEvent()
          this.eventid = item.id
          let _params = {
            userid: Cache.getUserInfo().id
          }
          API.findOneInfo(_params).then(resp => {
            this.formData.company = resp.data.companyname
          })
          this.asyncGetEventSignUp()
        }
      })
    },

    // 报名详情
    detail (item) {
      this.detailDialogVisible = true
      this.eventid = item.id
      let _params = {
        membershipid: this.id,
        eventid: this.eventid,
        currentPage: this.currentPage3,
        pageSize: this.pageSize3
      }
      API.getEventSignUp(_params).then(resp => {
        if (resp.resultCode === '0000') {
          this.tableData3 = resp.data.list
          this.total3 = resp.data.total
        }
      })
    },

    // 关闭会议报名弹框
    closeSignUpDialog () {
      this.signUpDialogVisible = false
      this.formData.name = ''
      this.formData.phone = ''
      this.formData.job = ''
    },

    // 关闭报名详情弹框
    closeDetailDialog () {
      this.detailDialogVisible = false
    },

    // 移除
    remove (item) {
      let params = {
        id: item.id
      }
      API.delEventSignUp(params).then(resp => {
        if (resp.resultCode === '0000') {
          this.$message.success(resp.resultMsg)
          this.asyncGetEventSignUp()
        }
      })
    },

    // 添加常用联系人
    increase  (item) {
      console.log(item)
      let params = {
        eventid: this.eventid, // 会议id
        membershipid: this.id,
        company: item.company,
        name: item.name,
        job: item.job,
        phone: item.phone
      }
      API.addEventSignUp(params).then(resp => {
        if (resp.resultCode === '0000') {
          this.$message.success(resp.resultMsg)
          this.asyncGetEventSignUp()
        } else {
          this.$message.error(resp.resultMsg)
        }
      })
      this.asyncGetEventSignUp()
    },
    // 添加
    add () {
      if (!this.formData.company) {
        this.$message.error('请输入所在单位')
        return
      }
      if (!this.formData.name) {
        this.$message.error('请输入姓名')
        return
      }
      if (!this.formData.phone) {
        this.$message.error('请输入联系电话')
        return
      }
      if (!this.formData.job) {
        this.$message.error('请输入职务')
        return
      }
      let params = {
        eventid: this.eventid,
        membershipid: this.id,
        company: this.formData.company,
        name: this.formData.name,
        job: this.formData.job,
        phone: this.formData.phone
      }
      API.addEventSignUp(params).then(resp => {
        if (resp.resultCode === '0000') {
          this.$message.success(resp.resultMsg)
          this.asyncGetEventSignUp()
        } else {
          this.$message.error(resp.resultMsg)
        }
      })
      this.asyncGetEventSignUp()
      this.formData.name = ''
      this.formData.phone = ''
      this.formData.job = ''
    },

    // 提交
    submit () {
      let params = {
        eventid: this.eventid,
        membershipid: this.id
      }
      API.updateEventAudit(params).then(resp => {
        if (resp.resultCode === '0000') {
          this.$message.success(resp.resultMsg)
          this.signUpDialogVisible = false
        } else {
          this.$message.error(resp.resultMsg)
        }
      })
    },

    // 查询常用联系人列表
    asyncGetLinkMenForEvent () {
      let params = {
        pageSize: this.pageSize4,
        currentPage: this.currentPage4,
        membershipid: this.id
      }
      API.getLinkMenForEvent(params).then(resp => {
        if (resp.resultCode === '0000') {
          this.tableData4 = resp.data.list
          this.total4 = resp.data.total
        }
      })
    },
    // 查询会议报名人员列表
    asyncGetEventSignUp () {
      let _params = {
        membershipid: this.id,
        eventid: this.eventid,
        currentPage: this.currentPage2,
        pageSize: this.pageSize2
      }
      API.getEventSignUp(_params).then(resp => {
        if (resp.resultCode === '0000') {
          this.tableData2 = resp.data.list
          this.total2 = resp.data.total
        }
      })
    },
    // 报名详情
    asyncGetEventSignUp2 () {
      let _params = {
        membershipid: this.id,
        eventid: this.eventid,
        currentPage: this.currentPage3,
        pageSize: this.pageSize3
      }
      API.getEventSignUp(_params).then(resp => {
        if (resp.resultCode === '0000') {
          this.tableData3 = resp.data.list
          this.total3 = resp.data.total
        }
      })
    },

    asyncGetEventForMem () {
      let params = {
        userid: Cache.getUserInfo().id
      }
      API.findOneInfo(params).then(resp => {
        if (resp.resultCode === '0000') {
          this.id = resp.data.id
        }
        let _params = {
          currentPage: this.currentPage,
          pageSize: this.pageSize,
          membershipid: this.id
        }
        API.getEventForMem(_params).then(resp => {
          if (resp.resultCode === '0000') {
            this.tableData = resp.data.list
            this.total = resp.data.total
          }
        })
      })
    },
    handleSizeChange (pageSize) {
      this.pageSize = pageSize
      this.asyncGetEventForMem()
    },
    handleCurrentChange (currentPage) {
      this.currentPage = currentPage
      this.asyncGetEventForMem()
    },
    handleSizeChange2 (pageSize) {
      this.pageSize2 = pageSize
      this.asyncGetEventSignUp()
    },
    handleCurrentChange2 (currentPage) {
      this.currentPage2 = currentPage
      this.asyncGetEventSignUp()
    },
    handleSizeChange3 (pageSize) {
      this.pageSize3 = pageSize
      this.asyncGetEventSignUp2()
    },
    handleCurrentChange3 (currentPage) {
      this.currentPage3 = currentPage
      this.asyncGetEventSignUp2()
    },
    handleSizeChange4 (pageSize) {
      this.pageSize4 = pageSize
      this.asyncGetLinkMenForEvent()
    },
    handleCurrentChange4 (currentPage) {
      this.currentPage4 = currentPage
      this.asyncGetLinkMenForEvent()
    }
  }
}
</script>

<style lang="scss">
.applyMain {
  .width-200 {
    .el-input {
      width: 200px;
    }
  }
  .el-dialog {
    width: 1000px;
  }
}
</style>
